import preparedReducer from './reducer';
import {
  updateFilterState,
  updateActivityLogFilter,
  updateIRFilter,
  updateMonitoringFilter,
  updateWorkHistoryFilter,
  updateTimesheetsFilter,
  reset,
  updateTab,
  updateActivityMapFilter,
  updateClientDashboardFilter,
  updateAdminClientFilter,
  updateAdminSiteFilter,
  updateAdminEmployeeFilter,
  updateAdminContactFilter,
  updateMobileUnitsFilter,
  setIsFilterSelected,
  updatePerformanceFilter,
  updateInfoBoardFilter,
  updateSort,
  updateFormResultsFilter,
  updateFormsFilter,
  updateTasksFilter,
  updateToursFilter,
  updateSystemLogFilter,
  updateVisitorsFilter,
  updateVisitorLogFilter,
  updateBIFilter,
  updateBIToursFilter,
  updateBranchesFilter,
  updateAdministratorsFilter,
  updatePDFReportsFilter,
  updateEntityPDFReportsFilter,
  updateBIIncidentReportsFilter,
  updateNotebookNotesFilter,
  updateBINotebookNotesFilter,
} from './actions';

import initState from './states';

export { initState };

export const reducer = preparedReducer;

export const SLICE_NAME = 'pageStore';

export const selectors = (state) => state[SLICE_NAME];

export const selectActivityLogFilters = (state) => state[SLICE_NAME].activityLogFilters;
export const selectorsInfoBoard = (state) => state[SLICE_NAME].infoBoardFilters;
export const selectorsMonitoring = (state) => state[SLICE_NAME].monitoringFilters;
export const selectorsIR = (state) => state[SLICE_NAME].irFilters;
export const selectorsPerformance = (state) => state[SLICE_NAME].performanceFilters;
export const selectorsSystemLog = (state) => state[SLICE_NAME].systemLogFilters;
export const selectVisitorsFilters = (state) => state[SLICE_NAME].visitorsFilters;
export const selectVisitorLogFilters = (state) => state[SLICE_NAME].visitorLogFilters;
export const selectFormsFilter = (state) => state[SLICE_NAME].formsFilters;
export const selectFormResultsFilter = (state) => state[SLICE_NAME].formResultsFilters;
export const selectBIFilters = (state) => state[SLICE_NAME].biFilters;
export const selectEventsBIFilters = (state) => state[SLICE_NAME].biFilters.events;
export const selectEntitiesBIFilters = (state) => state[SLICE_NAME].biFilters.entities;
export const selectBIToursFilters = (state) => state[SLICE_NAME].biToursFilters;
export const selectBIToursDateFilters = (state) => state[SLICE_NAME].biToursFilters.monthYear;
export const selectEmployeeFilters = (state) => state[SLICE_NAME].adminEmployeeFilters;
export const selectWorkHistoryFilters = (state) => state[SLICE_NAME].workHistoryFilters;
export const selectBranchesFilters = (state) => state[SLICE_NAME].branchesFilters;
export const selectAdministratorsFilters = (state) => state[SLICE_NAME].administratorsFilters;
export const selectPDFReportsFilters = (state) => state[SLICE_NAME].pdfReportsFilters;
export const selectEntityPDFReportsFilters = (state) => state[SLICE_NAME].entityPDFReportsFilters;
export const selectBIIncidentReportsFilters = (state) => state[SLICE_NAME].biIncidentReportsFilters;
export const selectNotebookNotesFilters = (state) => state[SLICE_NAME].notebookNotesFilters;
export const selectBINotebookNotesFilters = (state) => state[SLICE_NAME].biNotebookNotesFilters;
export const selectBINotebookNotesDateFilters = (state) => state[SLICE_NAME].biNotebookNotesFilters.monthYear;

export const actions = {
  updateFilterState,
  updateActivityLogFilter,
  updateIRFilter,
  updateMonitoringFilter,
  updateWorkHistoryFilter,
  updateTimesheetsFilter,
  updateActivityMapFilter,
  updateClientDashboardFilter,
  reset,
  updateTab,
  updateAdminClientFilter,
  updateAdminSiteFilter,
  updateAdminEmployeeFilter,
  updateAdminContactFilter,
  updateMobileUnitsFilter,
  setIsFilterSelected,
  updatePerformanceFilter,
  updateInfoBoardFilter,
  updateSort,
  updateFormResultsFilter,
  updateFormsFilter,
  updateTasksFilter,
  updateToursFilter,
  updateSystemLogFilter,
  updateVisitorsFilter,
  updateVisitorLogFilter,
  updateBIFilter,
  updateBIToursFilter,
  updateBranchesFilter,
  updateAdministratorsFilter,
  updatePDFReportsFilter,
  updateEntityPDFReportsFilter,
  updateBIIncidentReportsFilter,
  updateNotebookNotesFilter,
  updateBINotebookNotesFilter,
};
